export { REVIEW_DETAILS_SOURCES } from './constants';

// libs
import { connect } from 'react-redux';

// selectors
import { isLoggedIn } from 'store/app/selectors';

// components
import ReviewCard from 'shared/components//ReviewCard/ReviewCard';

const mapStateToProps = (state: any) => {
  return {
    isLoggedInUser: isLoggedIn(state),
  };
};

export default connect(mapStateToProps)(ReviewCard);
